module.exports = __webpack_public_path__ + "img/more-page.ea660ea7.png";